/* eslint-disable react/prop-types */
import { Link } from "react-router-dom";
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";

function ActionCell({ item }) {
  return (
    <SoftBox display="flex" alignItems="center" justifyContent="center">
      <Tooltip title="Xem chi tiết sổ cái">
        <SoftBox
          component={Link}
          to={item.viewLink}
          color="success"
          sx={{ cursor: "pointer", lineHeight: 0 }}
        >
          <Icon sx={{ fontWeight: "bold" }}>visibility</Icon>
        </SoftBox>
      </Tooltip>
    </SoftBox>
  );
}

export default ActionCell;
